"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var fontSmoothing = (0, _styledComponents.css)(["text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-smoothing:antialiased;-webkit-font-smoothing:antialiased;text-shadow:rgba(0,0,0,0.01) 0 0 1px;"]);
var _default = fontSmoothing;
exports["default"] = _default;